module.exports = __webpack_public_path__ + "assets/img/images_g.5975afd4.png";